import React, { useState } from 'react';
import CardComponent from './CardComponent';
import CardTextComponent from './CardTextComponent';

interface ToggleCardProps {
    imgPath: string;
    data: {
        id: number;
        name: string;
        office: string;
        end_date?: Date;
        icon: string;
        description: string;
        finished_stages: number;
        late_stages: number;
        over_year_late_stages: number;
        in_progress_stages: number;
        not_started_stages: number;
        current_stage: any;
        days_late: any;
    };
}

export default function ToggleCardComponent({ imgPath, data }: ToggleCardProps) {
    const [isTextMode, setIsTextMode] = useState(false);

    const handleToggle = () => {
        setIsTextMode(prev => !prev);
    };

    return isTextMode ? (
        <CardTextComponent imgPath={imgPath} data={data} onToggle={handleToggle} />
    ) : (
        <CardComponent imgPath={imgPath} data={data} onToggle={handleToggle} />
    );
}